import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface GetDataExtractionModelListParams {
	organization_id: string;
	company_id: string;
	limit?: number;
	offset?: number;
}

const Service = DataExtractionService.getInstance();

export const useGetDataExtractionModelList = (params: GetDataExtractionModelListParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION_MODEL_LIST],
		queryFn: () => Service.findAllModels(params)
	});
};
